/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2016 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
*/

import {
  Component,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

import { Map, Set } from 'immutable';

import { PathCache, JSONSchema } from '../shared/interfaces';
import { JsonStoreService, AppGlobalsService, TabsUtilService, KeysStoreService } from '../shared/services';


export class SubRecordComponent implements OnChanges {
   value: Map<string, any>;
   schema: JSONSchema;
   tabName: string;
   keys: Set<string>;
   pathString: string;

  keysByType: { others: Set<string>, toggles: Set<string> };
  pathCache: PathCache = {};

  constructor(public jsonStoreService: JsonStoreService,
    public appGlobalsService: AppGlobalsService,
    public tabsUtilService: TabsUtilService,
    public keysStoreService: KeysStoreService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['keys']) {
      let keys;
      if (this.tabName) {
        const keyToTabName = this.tabsUtilService.getSchemaKeyToTabName(this.appGlobalsService.config.tabsConfig, this.schema);
        keys = this.keys
          .filter(key => keyToTabName[key] === this.tabName);
      } else {
        keys = this.keys;
      }
      this.keysByType = keys
        .groupBy(key => this.isToggle(key) ? 'toggles' : 'others')
        .toObject() as any;
    }
  }

  // delete only work for others, not toggles (UPDATE: config comment if this changes)
  deleteField(field: string) {
    this.jsonStoreService.removeIn(this.getPathForChild(field));
  }

  getPathForChild(key: string): Array<any> {
    if (!this.pathCache[key]) {
      this.pathCache[key] = [key];
    }
    return this.pathCache[key];
  }

  onToggleValueChange(field: string, value: boolean) {
    this.jsonStoreService.setIn(this.getPathForChild(field), value);
  }

  private isToggle(field: string): boolean {
    return this.schema.properties[field].toggleColor !== undefined;
  }

  isDisabled(key): boolean {
    return this.schema.properties[key].disabled && !this.appGlobalsService.adminMode ;
  }

  isDeleteDisabled(key): boolean {
    return !this.schema.properties[key].isDeleteDisabled;
  }

  trackByElement(index: number, element: any): any {
    return element;
  }

  getTitleDropdownItemTemplateNamesForChild(key: string): Array<string> {
    return this.schema.properties[key].titleDropdownItemTemplateNames;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sub-record',
  styles: ["tr.align-right td:first-child { width: 100%; } tr.align-right td:first-child slide-toggle { float: right; } "],
  template: "<div class=\"record-fields-container\"> <table class=\"table\"> <div class=\"field-wrapper\"> <tr *ngIf=\"keysByType.toggles\" class=\"align-right\"> <td *ngFor=\"let key of keysByType.toggles; trackBy:trackByElement\"> <slide-toggle [id]=\"'/' + key\" [value]=\"value.get(key) | selfOrEmpty:schema.properties[key]\" (valueChange)=\"onToggleValueChange(key, $event)\" [onText]=\"key\" [offText]=\"key\" [onColor]=\"schema.properties[key].toggleColor\"></slide-toggle> </td> </tr> </div> <div *ngIf=\"keysByType.others\"> <div class=\"field-wrapper\" *ngFor=\"let key of keysByType.others | setFirstElementPath:tabName; trackBy:trackByElement\"> <tr> <td class=\"label-holder\"> <title-dropdown [title]=\"key | underscoreToSpace\" [isDisabled]=\"isDisabled(key)\"> <li *ngIf=\"schema.properties[key].type === 'array'\" class=\"title-dropdown-item\"> <add-new-element-button [path]=\"getPathForChild(key)\" [schema]=\"schema.properties[key]\"></add-new-element-button> </li> <li class=\"title-dropdown-item\" *ngIf=\"isDeleteDisabled(key)\"> <button type=\"button\" class=\"editor-btn-delete editor-btn-delete-text\" (click)=\"deleteField(key)\">Delete</button> </li> <ng-container *ngIf=\"getTitleDropdownItemTemplateNamesForChild(key)\"> <li *ngFor=\"let templateName of getTitleDropdownItemTemplateNamesForChild(key)\" class=\"title-dropdown-item custom-title-dropdown-item\"> <ng-template [ngTemplateOutlet]=\"appGlobalsService.templates[templateName]\"></ng-template> </li> </ng-container> <li class=\"divider\"></li> <li class=\"title-dropdown-item\" (click)=\"$event.stopPropagation()\"> <find-replace [path]=\"getPathForChild(key)\" [schema]=\"schema.properties[key]\"></find-replace> </li> </title-dropdown> </td> </tr> <tr> <td> <any-type-field [value]=\"value.get(key) | selfOrEmpty:schema.properties[key]\" [schema]=\"schema.properties[key]\" [path]=\"getPathForChild(key)\"></any-type-field> </td> </tr> </div> </div> </table> </div> ",
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: JsonStoreService, },
{type: AppGlobalsService, },
{type: TabsUtilService, },
{type: KeysStoreService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'value': [{ type: Input },],
'schema': [{ type: Input },],
'tabName': [{ type: Input },],
'keys': [{ type: Input },],
'pathString': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
